module.exports = __webpack_public_path__ + "img/6_112.25a1042e.png";